import { Component, ComponentFactoryResolver, ComponentRef, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild, ViewContainerRef } from '@angular/core';
import { ViewsService } from '../../views.service';
import { CustomComponent } from './custom-component.interface';

@Component({
  selector: 'app-view-component-custom',
  templateUrl: 'view-component-custom.component.html',
  styleUrls: ['view-component-custom.component.scss'],
})
export class ViewComponentCustomComponent {

  //@ViewChild("customComponentContainer", { static: true }) public customComponentContainer: ElementRef;
  @ViewChild('customComponentContainer', { read: ViewContainerRef }) customComponentContainer: ViewContainerRef;
  //@ViewChild(AdDirective, { static: true }) adHost!: AdDirective;

  
  @Output() onEvent: EventEmitter<any> = new EventEmitter();
  
  @Input("component") public component:any = {};
  @Input("index") public index:number = 0;
  @Input("model") public model:any = {};
  @Input("showConfigOptions") public showConfigOptions:boolean = false;

  private componentRef:ComponentRef<CustomComponent> = null;


  constructor(
    public viewContainerRef: ViewContainerRef,
    private viewsService:ViewsService,
    private componentFactoryResolver: ComponentFactoryResolver
  ) { 
  }

  ngAfterViewInit(): void {
    let component = this.viewsService.GetComponentByName(this.component.component);
    const componentFactory = this.componentFactoryResolver.resolveComponentFactory(component);
    this.componentRef = this.customComponentContainer.createComponent<CustomComponent>(componentFactory);
    this.componentRef.instance.data = this.model;
  }

  fireEvent(component:string, event:string, args:any){
    if(event=="reload"){
      this.componentRef.instance.onEvent(component, event, args);
    }
  }

}
